module.exports = __webpack_public_path__ + "img/qrland.28ffcdee.webp";